// SS PWA — components/diagnostics/TenantSwitcher.tsx — 2026-06-03
//
// Cross-tenant dropdown for the operator admin view. Only used in
// /admin/diagnostics. Not exposed to the client owner view.

import { useEffect, useState } from 'react';
import { listTenants, type TenantListItem, DiagnosticsApiError } from '@/lib/api/diagnostics';

interface TenantSwitcherProps {
  value: string;
  onChange: (slug: string) => void;
}

export function TenantSwitcher({ value, onChange }: TenantSwitcherProps) {
  const [tenants, setTenants] = useState<TenantListItem[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void listTenants()
      .then((rows) => {
        if (cancelled) return;
        setTenants(rows);
        setError(null);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        if (err instanceof DiagnosticsApiError) {
          setError(`API ${err.status}`);
        } else {
          setError(err instanceof Error ? err.message : String(err));
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="tenant" className="text-xs font-medium text-ink-600 dark:text-[#94A3B8]">
        Tenant
      </label>
      <select
        id="tenant"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="rounded-md border border-ink-200 bg-white px-2 py-1 text-sm text-ink-900 dark:border-[#1F2A37] dark:bg-[#0F172A] dark:text-white"
      >
        <option value="">— select —</option>
        {tenants.map((t) => (
          <option key={t.slug} value={t.slug}>
            {t.display_name} ({t.slug})
          </option>
        ))}
      </select>
      {error ? (
        <span className="text-xs text-red-500" title={error}>
          • tenant list error
        </span>
      ) : null}
    </div>
  );
}
